<template>
  <Teleport to=".fd-header .navbar-title-block" :disabled="!teleportReady">
    <div
      class="v-breadcrumbs embedded-breadcrumb-trail"
      :class="{ 'dark-mode': isDarkMode }"
    >
      <button
        v-if="showHome"
        type="button"
        class="home-img"
        title="Home"
        aria-label="Home"
        @click="onHomeClick"
      >
        <img
          :src="homeIcon"
          class="cursor-pointer"
          width="20"
          height="20"
          alt=""
        />
      </button>
      <template v-if="items.length">
        <span
          v-if="showHome"
          class="embedded-breadcrumb-divider"
          aria-hidden="true"
        >
          <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1 1L5 5.5L1 10"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <template v-for="(item, index) in items" :key="`crumb-${index}-${item.title}`">
          <span
            v-if="index > 0"
            class="embedded-breadcrumb-divider"
            aria-hidden="true"
          >
            <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1 1L5 5.5L1 10"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <div class="text-capitalize embedded-breadcrumb-item">
            <a
              v-if="item.pvtPath && !item.nonNav && homeMode === 'pvt'"
              href="#"
              @click.prevent="onPvtItemClick(item)"
            >
              {{ item.title }}
            </a>
            <router-link v-else-if="item.href && !item.nonNav" :to="item.href">
              {{ item.title }}
            </router-link>
            <span v-else>{{ item.title }}</span>
          </div>
        </template>
      </template>
    </div>
  </Teleport>
</template>

<script>
import { mapGetters } from "vuex";
import { navigateHome } from "@/utils/navHome";

export default {
  name: "EmbeddedBreadcrumbBar",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    homeMode: {
      type: String,
      default: "assets",
      validator: (v) => ["assets", "agentic", "pvt"].includes(v),
    },
    showHome: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      homeIcon: require("@/assets/Svg/Icons/home.svg"),
      teleportReady: false,
    };
  },
  computed: {
    ...mapGetters("darkMode", ["isDarkMode"]),
  },
  mounted() {
    this.teleportReady = !!document.querySelector(".fd-header .navbar-title-block");
  },
  methods: {
    onHomeClick() {
      if (this.homeMode === "agentic") {
        this.$router.push({ name: "AgenticDashboard" });
        return;
      }
      if (this.homeMode === "pvt") {
        this.$emit("pvt-navigate", "/");
        return;
      }
      navigateHome(this.$router, this.$route);
    },
    onPvtItemClick(item) {
      if (item?.pvtPath) {
        this.$emit("pvt-navigate", item.pvtPath);
      }
    },
  },
};
</script>
